module.exports = __webpack_public_path__ + "img/qu_ir.e14c843.jpg";